export default __webpack_public_path__ + "static/media/credit-card@2x.dd015872.png";